export enum DiagnosisEnum {
    Diagnosis = "diagnosis",
    StartDate = "startDate",
    ConfirmationStatus = "confirmationStatus"  
}

export enum DiagnosisStatusEnum{
    StatusLabel = 'diagnose status:',
    DanishActive = 'diagnose status: aktive',
    DanishInactive = 'diagnose status: inaktive',
    EnglishActive = 'diagnose status: active',
    EnglishInactive = 'diagnose status: inactive',
}

export const DiagnosisTranslations: Record<
    DiagnosisEnum,
    { en: string[]; da: string[] }
> = {
    [DiagnosisEnum.Diagnosis]: {
        en: ["Diagnosis"],
        da: ["Diagnose"]
    },
    [DiagnosisEnum.StartDate]: {
        en: ["Start date"],
        da: ["Start dato"]
    },
    [DiagnosisEnum.ConfirmationStatus]: {
        en: ["Confirmation status"],
        da: ["Bekræftelses status"]
    }
};